export const DEFAULT_DISCOUNT = 25
